import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { TlkLoadingSpinnerComponent } from '@itero/ui-toolkit-angular/loading-spinner';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'rx-delayed-spinner',
	standalone: true,
	imports: [CommonModule, TlkLoadingSpinnerComponent],
	template: '<tlk-loading-spinner *ngIf="visible" [size]="size"></tlk-loading-spinner>',
	styles: [
		`
			:host {
				display: contents;
			}
		`
	]
})
export class DelayedSpinnerComponent implements OnChanges, OnDestroy {
	@Input() loading = false;
	@Input() size = 48;
	@Input() delay = 200;

	visible = false;
	private timer: ReturnType<typeof setTimeout> | null = null;

	ngOnChanges(): void {
		if (this.loading) {
			if (!this.timer) {
				this.timer = setTimeout(() => {
					this.visible = true;
					this.timer = null;
				}, this.delay);
			}
		} else {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.visible = false;
		}
	}

	ngOnDestroy(): void {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	}
}
